import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
    selector: 'material-slidetoggle',
    templateUrl: './slidetoggle.component.html',
    styleUrls: ['./slidetoggle.component.css'],
    standalone: false,
})
export class MaterialSlidetoggleComponent implements OnInit, OnDestroy {
    @Input() name: string | null;
    @Input() nameClasses: string;
    @Input() id: string;
    @Input() model: boolean;
    @Input() disabled: boolean;
    @Input() dontChangeImmediately: boolean;

    @Output() change = new EventEmitter<boolean>();
    @Output() modelChange = new EventEmitter<boolean>();
    @Output() changeToggle = new EventEmitter<any>();

    counter = 0;

    constructor() {}

    onToggleChange = (event: Event) => {
        if (this.disabled) return;

        const input = event.target as HTMLInputElement;
        const isChecked = input.checked;

        if (this.dontChangeImmediately) {
            // If we shouldn't change immediately, revert the checkbox state
            // The parent component is expected to update [model] later
            input.checked = this.model;
        } else {
            this.model = isChecked;
        }

        this.modelChange.emit(isChecked);
        this.changeToggle.emit({ model: isChecked, inputSource: isChecked });
        this.change.emit(isChecked);
    };

    changeStatus = () => {
        this.counter = this.counter + 1;
        this.changeToggle.emit(this.counter);
    };

    ngOnInit() {}

    ngOnDestroy() {}
}
